var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ifmf_sub"},[_vm._v(_vm._s(_vm.$t('s_c_request', {nick : _vm.memberData.mb_nick})))])
}
var staticRenderFns = []

export { render, staticRenderFns }